// extracted by mini-css-extract-plugin
export default {"invitation":"InvitationLayout_invitation__b8+-9","container":"InvitationLayout_container__zp6+h","animation":"InvitationLayout_animation__xxZVj"};